export const isObjectEmpty = (obj) => {
  if (!obj) return true;
  return obj && Object.entries(obj).length === 0 && obj.constructor === Object;
};

export const defaultTwinCoverPhoto =
  'https://testsdc.unisot.id/api/lookup/raw/23a36015-cab7-42d3-b1fd-e39d427238e8/KTQ0AVR.jpg';
export const defaultTwinDisplayPicture =
  'https://testsdc.unisot.id/api/lookup/raw/41e3ea71-24c7-4e35-957b-6fed283a5c64/iS93rK7.jpg';
